import { useEffect, useState } from "react"
import axios from "axios"
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { getFirstDayOfWeek } from "../../utils/dateUtility";
import moment from 'moment'

export const CallHistoryComponent = () => {

    let thisWeek = getFirstDayOfWeek();

    let historyDates = [
        {
            label : "s",
            dateMin: thisWeek.clone(),
            dateMax: thisWeek.clone().add(6, 'days')
        },
        {
           label : "s-1",
            dateMin: thisWeek.clone().add(-7, 'days'),
            dateMax: thisWeek.clone().add(-1, 'days')
        },
        {
            label: "s-2",
            dateMin: thisWeek.clone().add(-14, 'days'),
            dateMax: thisWeek.clone().add(-8, 'days')
        },
        {
            label: "s-3",
            dateMin: thisWeek.clone().add(-21, 'days'),
            dateMax: thisWeek.clone().add(-15, 'days')
        },
        {
            label: "s-4",
            dateMin: thisWeek.clone().add(-28, 'days'),
            dateMax: thisWeek.clone().add(-22, 'days')
        },
        {
            label: "s-5",
            dateMin: moment(thisWeek).clone().add(-35, 'days'),
            dateMax: moment(thisWeek).clone().add(-29, 'days')
        },
        {
            label: "s-6",
            dateMin: moment(thisWeek).clone().add(-42, 'days'),
            dateMax: moment(thisWeek).clone().add(-36, 'days')
        },
    ]

    let [dateLabel, setDateLabel] = useState(historyDates[0].label);
    let [history, setHistory] = useState([]);
    let [headers, setHeaders] = useState([]);

    const [filters] = useState({

        nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

        prenom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },

    });

    useEffect(() => {

        let dateRange = historyDates.find(x => x.label === dateLabel);

        if (!dateRange) {
            return;
        }


        axios.get("/api/callhistory/get-history-between?dateMin=" +  dateRange.dateMin.format("YYYY-MM-DD") + "&dateMax=" + dateRange.dateMax.clone().add(1,"days").format("YYYY-MM-DD" )).then(response => {

            let pages = new Set();

            response.data.forEach(x => {
                let keys = Object.keys(x.pages).forEach(y => pages.add(y));
            })

            let tmpArray = [];

            response.data.forEach(x => {

                let tmpRow =  { nom : x.nom, prenom : x.prenom }


                Object.keys(x.pages).forEach(y => {
                    let value = x.pages[y];
                    tmpRow[y] = value;
                });

                pages.forEach(x => {
                    if (!tmpRow[x]) {
                        tmpRow[x] = 0;
                    }
                })

                tmpArray.push(tmpRow);

            });

            setHistory(tmpArray);
            setHeaders([...pages]);
        }
        )

    }, [dateLabel])


    let selectNbDays = <div className="my-5" >
        <div className="form-group">
        <label for="nbDays">Période</label>
        <select id="nbDays" className="form-select" value={dateLabel} onChange={e => setDateLabel(e.target.value)} >
                {
                    historyDates.map((x, i) =>  <option key={i} value={x.label} >Du {x.dateMin.format('LL')} au {x.dateMax.format('LL')}</option>)
                }

            </select>
        </div>
    </div>

    if (!history.length) {
        return <div> {selectNbDays} <div>aucune donnée</div></div>
    }

    return <div>
        {selectNbDays }
        <DataTable value={history} filters={filters} >
            <Column field="prenom" header="Prénom" filter />
            <Column field="nom" header="Nom" filter />
            {headers.map(x => (

                <Column key={x} field={x} header={x} sortable />

            ))}

        </DataTable>
    </div>
}
